import React from 'react';
import classnames from 'classnames';
import { Row, Col } from 'react-bootstrap';

const DEFAULT_COMPACT_DESCRIPTION_MAX_HEIGHT = 60;

export default ({ session, topOfSessionViewRef, shouldUseCompactDescription, descriptionMaxHeight = DEFAULT_COMPACT_DESCRIPTION_MAX_HEIGHT }) => {

    const [compactDescriptionNeeded, setCompactDescriptionNeeded] = React.useState(false);
    const [compactDescriptionExpanded, setCompactDescriptionExpanded] = React.useState(false);
    const descriptionRef = React.useRef();

    React.useEffect(() => {
        shouldUseCompactDescription && requestAnimationFrame(() => {
            const descriptionTotalHeight = descriptionRef.current?.scrollHeight || 0;
            if (descriptionTotalHeight > descriptionMaxHeight) {
                setCompactDescriptionNeeded(true);
                setCompactDescriptionExpanded(false);
            }
        });
    }, [descriptionMaxHeight, shouldUseCompactDescription]);

    function toggleCompactDescription() {
        if (compactDescriptionExpanded) {
            topOfSessionViewRef.current.scrollIntoView();
        }
        setCompactDescriptionExpanded(!compactDescriptionExpanded);
    }

    const descriptionIsCompacted = compactDescriptionNeeded && !compactDescriptionExpanded;
    const descriptionClass = classnames(
        'session-description white-space-pre',
        {'compact-description': descriptionIsCompacted});
    return <Row>
        <Col md={12} lg={12}>
            <div className={descriptionClass} ref={descriptionRef} dangerouslySetInnerHTML={{__html: session?.descriptionHtml}}/>
            {compactDescriptionNeeded &&
                <div
                    onClick={toggleCompactDescription}
                    className="show-more-button color-1">
                    {compactDescriptionExpanded ? 'View Less' : 'View More'}
                </div>}
        </Col>
    </Row>;
};
